import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=d4d3ca5c&scoped=true&"
import script from "./SectionHead.vue?vue&type=script&lang=js&"
export * from "./SectionHead.vue?vue&type=script&lang=js&"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=d4d3ca5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3ca5c",
  null
  
)

export default component.exports